"use strict";

var defaultShrinkWrapQuantityDivisor = 40;

module.exports = function (accumulator, order, product, component, options) {
  if (component.is_sample) {
    return 0;
  }

  var numToAdd = 0;

  if (parseInt(component.quantity, 10) > 5) {
    numToAdd = component.num_to_add == null ? 4 : component.num_to_add;
    var quantity = parseInt(component.quantity, 10) + parseInt(numToAdd, 10);
    var shrinkWrapQuantityDivisor = options.shrinkWrapQuantityDivisor || defaultShrinkWrapQuantityDivisor;
    var div = Math.max(1, Math.round(quantity / shrinkWrapQuantityDivisor));
    var wrap_charge = div * 0.5;
    return wrap_charge;
  }

  return 0;
};